/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Select, Form, Checkbox, Row, Col, Tooltip } from 'antd'
import { MinusCircleOutlined } from '@ant-design/icons'
import { Questions } from '../../../hooks/useGerateQuestions'
import MainSubcomponents from './components/MainSubcomponents'
import ComponentSubComponents from './components/ComponentSubComponents'
import AdditionalCharacteristic from './components/AdditionalCharacteristic'
import ComponentsForCharacteristics from './components/ComponentsForCharacteristics'
import FormatUserDefined from './components/FormatUserDefined'
import Characteristic from './components/Characteristic'
import { getCurrentListItemIndex } from '../../getCurrentListItemIndex'
import SubcomponentsForCharacteristics from './components/MachineSubcomponentsForCharacteristics'
// import CrossReferenceAndReletedApplication from './components/CrossReferenceAndReletedApplicationMachineForm'
import CommunicatePatentPro from './components/CommunicatePatentPro'
import SubCharacteristic from './components/SubCharacteristic'
import SubAdditionalCharacteristic from './components/SubAdditionalCharacteristic'
import SubFormatUserDefined from './components/SubFormatUserDefined'
import AdditionalComponentsForCharacteristics from './components/AdditionalComponentsForCharacteristics'
import AddCompCharacteristic from './components/AddCompCharacteristic'
import AddCompAdditionalCharacteristic from './components/AddCompAdditionalCharacteristic'
import AddCompFormatUserDefined from './components/AddCompFormatUserDefined'
import SummaryOfSelectedEmbodimentsOfTheInvention from './components/MachineSummaryOfSelectedEmbodimentsOfTheInvention'
import DrawingsDescription from './components/DrawingsDescription'
import PartsOfIndependentClaim from './components/PartsOfIndependentClaim'
import SubSummaryOfSelectedEmbodimentsOfTheInvention from './components/MachineSubSummaryOfSelectedEmbodimentsOfTheInvention'
import AbstractOfTheDisclosure from './components/MachineAbstractOfTheDisclosure'
import ImportantComponentConnections from './components/ImportantComponentConnections'
import ImportantComponentsArrangements from './components/importantComponentsArrangements'
import DependantComponentConnections from './components/DependantComponentConnections'
import Title from './components/Title'
import PrimaryComponents from './components/PrimaryComponents'
import PrimaryAdditionalComponents from './components/PrimaryAdditionalComponents'
import CommonName from './components/CommonName'
import CustomBackgroundOfInnovation from './components/CustomBackgroundOfInnovationMachineForm'
import DetailedDescription from './components/DetailedDescription'
import { MachineForm, MachineNames, MachineValues, SharedNames } from './types'
import { CustomFormInstance } from '../../../types'
import {
    StyledSpan,
    StyledFormItem,
    StyledInput,
    StyledInputOptional,
} from './methods.styles'
import FeaturesPartsOfIndependentClaim from './components/FeaturesPartsOfIndependentClaim'
import { extractComponentName } from '../../functions'

type GetMethodsElementsArgs = {
    form: CustomFormInstance<MachineForm>
    setActiveQuestions: React.Dispatch<React.SetStateAction<string[]>>
    activeQuestions: string[]
    currentQuestionIndex: number
    setCurrentQuestionIndex: React.Dispatch<React.SetStateAction<number>>
    setContentBasedItemsToReview: React.Dispatch<
        React.SetStateAction<ValidQuestionKeys[]>
    >
    functions: any
}
const prepareCharacteristicQuestionsForComp = (
    questionsArray: string[],
    startIndex: number
) => {
    const questionsCopy = [...questionsArray]
    questionsCopy[startIndex + 1] = MachineNames.characteristic
    questionsCopy[startIndex + 2] = MachineNames.additionalCharacteristic
    questionsCopy[startIndex + 3] = MachineNames.formatUserDefined
    return questionsCopy
}

const prepareCharacteristicQuestionsForSubComp = (
    questionsArray: string[],
    startIndex: number
) => {
    const questionsCopy = [...questionsArray]
    questionsCopy[startIndex + 1] = MachineNames.subCharacteristic
    questionsCopy[startIndex + 2] = MachineNames.subAdditionalCharacteristic
    questionsCopy[startIndex + 3] = MachineNames.subFormatUserDefined
    return questionsCopy
}

const prepareCharacteristicQuestionsForAddComp = (
    questionsArray: string[],
    startIndex: number
) => {
    const questionsCopy = [...questionsArray]
    questionsCopy[startIndex + 1] = MachineNames.addCompCharacteristic
    questionsCopy[startIndex + 2] = MachineNames.addCompAdditionalCharacteristic
    questionsCopy[startIndex + 3] = MachineNames.addCompFormatUserDefined
    return questionsCopy
}

let subcomponentDiff = 0
let currentComponent = 0

export const getMachineElements = ({
    form,
    setActiveQuestions,
    activeQuestions,
    currentQuestionIndex,
    setCurrentQuestionIndex,
    setContentBasedItemsToReview,
    functions,
}: GetMethodsElementsArgs): Questions<MachineForm> => ({
    titleComponent: {
        component: <Title initialValue="MACHINE FOR" />,
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] = SharedNames.commonName
                return newValues
            })
        },
        name: SharedNames.titleComponent,
        formInputProps: {
            label: 'Please select the title of the invention and list all the inventors',
        },
    },
    commonName: {
        component: <CommonName />,
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.primaryComponents
                return newValues
            })
        },
        name: SharedNames.commonName,
        formInputProps: {
            label: 'If the machine has a common name, what is it?',
        },
    },
    primaryComponents: {
        component: <PrimaryComponents name={MachineNames.primaryComponents} />,
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.primaryAdditionalComponents
                return newValues
            })
        },
        name: MachineNames.primaryComponents,
        formInputProps: {
            label: (
                <label>
                    Please list the{' '}
                    <Tooltip
                        title="Examples of primary components include components that you believe are necessary
                     for the invention to work, necessary to describe how the invention is novel, or necessary to explain how any other primary components are connected."
                    >
                        <span style={{ textDecoration: 'underline' }}>
                            primary components
                        </span>
                    </Tooltip>{' '}
                    of the machine and select a corresponding indefinite
                    article. (These primary components will occur in the parent
                    claim rather than children claims.)
                </label>
            ),
        },
    },
    primaryAdditionalComponents: {
        component: (
            <PrimaryAdditionalComponents
                name={MachineNames.primaryAdditionalComponents}
            />
        ),
        onNext: () => {
            const additionalComponents = form.getFieldValue<
                MachineForm['primaryAdditionalComponents']
            >(MachineNames.primaryAdditionalComponents)
            if (additionalComponents && additionalComponents.length) {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.additionalComponentsForCharacteristics
                    return newValues
                })
            } else {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.mainSubcomponents
                    return newValues
                })
            }
        },
        name: MachineNames.primaryAdditionalComponents,
        formInputProps: {
            label: (
                <label>
                    If there are any additional components of the machine that
                    are not subcomponents of the primary components, please list
                    them now. (These components will appear in children claims.)
                </label>
            ),
        },
    },
    [MachineNames.additionalComponentsForCharacteristics]: {
        name: MachineNames.additionalComponentsForCharacteristics,
        component: <AdditionalComponentsForCharacteristics form={form} />,
        formInputProps: {
            label: 'Select the following additional components that have characteristics that you would like to further describe:',
        },
        onNext: () => {
            const additionalComponentsForCharacteristics = form.getFieldValue<
                MachineForm['additionalComponentsForCharacteristics']
            >(MachineNames.additionalComponentsForCharacteristics)
            if (
                additionalComponentsForCharacteristics &&
                additionalComponentsForCharacteristics.length
            ) {
                const newQuestions = prepareCharacteristicQuestionsForAddComp(
                    activeQuestions,
                    currentQuestionIndex
                )
                setActiveQuestions(newQuestions)
            } else {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.mainSubcomponents
                    return newValues
                })
            }
        },
    },
    [MachineNames.addCompCharacteristic]: {
        component: (
            <AddCompCharacteristic
                form={form}
                characteristicAdditionalComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.addCompCharacteristic
                )}
            />
        ),
        name: MachineNames.addCompCharacteristic,
        formInputProps: {
            label: undefined,
        },
    },
    [MachineNames.addCompAdditionalCharacteristic]: {
        component: (
            <AddCompAdditionalCharacteristic
                form={form as any}
                characteristicAdditionalComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.addCompAdditionalCharacteristic
                )}
            />
        ),
        name: MachineNames.addCompAdditionalCharacteristic,
        formInputProps: {
            label: 'Select the additional characteristics that you would like to add and fill in any applicable blanks.',
        },
    },
    [MachineNames.addCompFormatUserDefined]: {
        component: (
            <AddCompFormatUserDefined
                form={form as any}
                characteristicAdditionalComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.addCompFormatUserDefined
                )}
            />
        ),
        name: MachineNames.addCompFormatUserDefined,
        onNext: () => {
            const currentListItemIndex = getCurrentListItemIndex(
                activeQuestions,
                currentQuestionIndex + 1,
                MachineNames.addCompFormatUserDefined
            )

            const additionalComponentsForCharacteristics =
                form.getFieldValue<
                    MachineForm['additionalComponentsForCharacteristics']
                >('additionalComponentsForCharacteristics') ?? []

            if (
                currentListItemIndex <
                additionalComponentsForCharacteristics.length
            ) {
                const newQuestions = prepareCharacteristicQuestionsForAddComp(
                    activeQuestions,
                    currentQuestionIndex
                )
                setActiveQuestions(newQuestions)
            } else {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.mainSubcomponents
                    return newValues
                })
            }
        },
        formInputProps: {
            label: 'Select a format for the user defined variable and fill in the applicable blanks.',
        },
    },
    mainSubcomponents: {
        component: <MainSubcomponents form={form} />,
        name: MachineNames.mainSubcomponents,
        onNext: () => {
            const mainSubcomponents = form.getFieldValue<
                MachineForm['mainSubcomponents']
            >(MachineNames.mainSubcomponents)
            const nextComponent =
                mainSubcomponents && mainSubcomponents.length
                    ? MachineNames.primaryComponentSubComponentsList
                    : MachineNames.componentsForCharacteristics
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] = nextComponent
                return newValues
            })
        },
        formInputProps: {
            label: 'Please select the primary components that have subcomponents you would like to describe:',
        },
    },
    [MachineNames.primaryComponentSubComponentsList]: {
        component: (
            <ComponentSubComponents
                form={form}
                subComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.primaryComponentSubComponentsList
                )}
            />
        ),
        name: MachineNames.primaryComponentSubComponentsList,
        onNext: () => {
            const currentListItemIndex = getCurrentListItemIndex(
                activeQuestions,
                currentQuestionIndex + 1,
                MachineNames.primaryComponentSubComponentsList
            )
            const mainSubcomponents =
                form.getFieldValue<MachineForm['mainSubcomponents']>(
                    MachineNames.mainSubcomponents
                ) ?? []

            const nextComponent =
                currentListItemIndex < mainSubcomponents.length
                    ? MachineNames.primaryComponentSubComponentsList
                    : MachineNames.componentsForCharacteristics

            setActiveQuestions((prev) => {
                const newValues = [...prev]
                if (nextComponent)
                    newValues[currentQuestionIndex + 1] = nextComponent
                return newValues
            })
        },
    },
    [MachineNames.componentsForCharacteristics]: {
        name: MachineNames.componentsForCharacteristics,
        component: <ComponentsForCharacteristics form={form} />,
        formInputProps: {
            label: 'Select the following components that have characteristics that you would like to further describe:',
        },
        onNext: () => {
            const componentsForCharacteristics = form.getFieldValue<
                MachineForm['componentsForCharacteristics']
            >(MachineNames.componentsForCharacteristics)
            if (
                componentsForCharacteristics &&
                componentsForCharacteristics.length
            ) {
                const newQuestions = prepareCharacteristicQuestionsForComp(
                    activeQuestions,
                    currentQuestionIndex
                )
                setActiveQuestions(newQuestions)
            } else {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.partsOfIndependentClaim
                    return newValues
                })
            }
        },
    },
    characteristic: {
        component: (
            <Characteristic
                form={form}
                characteristicComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.characteristic
                )}
            />
        ),
        name: MachineNames.characteristic,
        formInputProps: {
            label: undefined,
        },
    },
    [MachineNames.additionalCharacteristic]: {
        component: (
            <AdditionalCharacteristic
                form={form as any}
                characteristicComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.additionalCharacteristic
                )}
            />
        ),
        name: MachineNames.additionalCharacteristic,
        formInputProps: {
            label: 'Select the additional characteristics that you would like to add and fill in any applicable blanks.',
        },
    },
    [MachineNames.formatUserDefined]: {
        component: (
            <FormatUserDefined
                form={form as any}
                characteristicComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.formatUserDefined
                )}
            />
        ),
        name: MachineNames.formatUserDefined,
        onNext: () => {
            const currentListItemIndex = getCurrentListItemIndex(
                activeQuestions,
                currentQuestionIndex + 1,
                MachineNames.formatUserDefined
            )

            const componentsForCharacteristics =
                form.getFieldValue<MachineForm['componentsForCharacteristics']>(
                    'componentsForCharacteristics'
                ) ?? []

            const primaryComponentId =
                componentsForCharacteristics[
                    getCurrentListItemIndex(
                        activeQuestions,
                        currentQuestionIndex,
                        MachineNames.formatUserDefined
                    )
                ]

            const mainSubcomponents =
                form.getFieldValue<MachineForm['mainSubcomponents']>(
                    'mainSubcomponents'
                ) ?? []

            if (currentListItemIndex < componentsForCharacteristics.length) {
                const newQuestions = prepareCharacteristicQuestionsForComp(
                    activeQuestions,
                    currentQuestionIndex
                )
                setActiveQuestions(newQuestions)
            } else {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.partsOfIndependentClaim
                    return newValues
                })
            }
            if (mainSubcomponents.includes(primaryComponentId)) {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.subcomponentsForCharacteristics
                    return newValues
                })
            }
        },
        formInputProps: {
            label: 'Select a format for the user defined variable and fill in the applicable blanks.',
        },
    },
    subcomponentsForCharacteristics: {
        name: MachineNames.subcomponentsForCharacteristics,
        component: (
            <SubcomponentsForCharacteristics
                form={form}
                subComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.characteristic
                )}
            />
        ),
        formInputProps: {
            label: undefined,
        },
        onNext: () => {
            const componentsForCharacteristics =
                form.getFieldValue<MachineForm['componentsForCharacteristics']>(
                    'componentsForCharacteristics'
                ) ?? []
            const primaryComponentIndex = getCurrentListItemIndex(
                activeQuestions,
                currentQuestionIndex,
                MachineNames.characteristic
            )
            const subComponentIndex = getCurrentListItemIndex(
                activeQuestions,
                currentQuestionIndex,
                MachineNames.subCharacteristic
            )
            if (currentComponent !== primaryComponentIndex - 1) {
                subcomponentDiff += subComponentIndex
                currentComponent = primaryComponentIndex - 1
            }
            const primaryComponentId =
                componentsForCharacteristics[primaryComponentIndex - 1]

            const subcomponentsForCharacteristics = form.getFieldValue<
                MachineForm['subcomponentsForCharacteristics']
            >('subcomponentsForCharacteristics')

            if (subcomponentsForCharacteristics) {
                const choosenSubcomponents =
                    subcomponentsForCharacteristics[primaryComponentId]
                if (choosenSubcomponents && choosenSubcomponents.length) {
                    const newQuestions =
                        prepareCharacteristicQuestionsForSubComp(
                            activeQuestions,
                            currentQuestionIndex
                        )
                    setActiveQuestions(newQuestions)
                }
                // TODO: add proper fallback there
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.partsOfIndependentClaim
                    return newValues
                })
            } else if (
                primaryComponentIndex < componentsForCharacteristics.length
            ) {
                const newQuestions = prepareCharacteristicQuestionsForComp(
                    activeQuestions,
                    currentQuestionIndex
                )
                setActiveQuestions(newQuestions)
            } else {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.partsOfIndependentClaim
                    return newValues
                })
            }
        },
    },
    [MachineNames.subCharacteristic]: {
        component: (
            <SubCharacteristic
                form={form}
                characteristicComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.characteristic
                )}
                characteristicSubComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.subCharacteristic
                )}
                countDiff={subcomponentDiff}
            />
        ),
        name: MachineNames.subCharacteristic,
        formInputProps: {
            label: undefined,
        },
    },
    [MachineNames.subAdditionalCharacteristic]: {
        component: (
            <SubAdditionalCharacteristic
                form={form}
                characteristicComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.characteristic
                )}
                characteristicSubComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.subAdditionalCharacteristic
                )}
                countDiff={subcomponentDiff}
            />
        ),
        name: MachineNames.subAdditionalCharacteristic,
        formInputProps: {
            label: 'Select the additional characteristics that you would like to add and fill in any applicable blanks.',
        },
    },
    [MachineNames.subFormatUserDefined]: {
        component: (
            <SubFormatUserDefined
                form={form}
                characteristicComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.characteristic
                )}
                characteristicSubComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.subFormatUserDefined
                )}
                countDiff={subcomponentDiff}
            />
        ),
        name: MachineNames.subFormatUserDefined,
        onNext: () => {
            const currentListComponentIndex = getCurrentListItemIndex(
                activeQuestions,
                currentQuestionIndex,
                MachineNames.characteristic
            )
            const componentsForCharacteristics = form.getFieldValue<
                MachineForm['componentsForCharacteristics']
            >('componentsForCharacteristics')

            const componentName =
                componentsForCharacteristics[currentListComponentIndex - 1]

            const currentListSubComponentIndex = getCurrentListItemIndex(
                activeQuestions,
                currentQuestionIndex + 1,
                MachineNames.subFormatUserDefined
            )

            const subcomponentsForCharacteristics = form.getFieldValue<
                MachineForm['subcomponentsForCharacteristics']
            >('subcomponentsForCharacteristics')[componentName]

            if (
                currentListSubComponentIndex - subcomponentDiff <
                subcomponentsForCharacteristics.length
            ) {
                const newQuestions = prepareCharacteristicQuestionsForSubComp(
                    activeQuestions,
                    currentQuestionIndex
                )
                setActiveQuestions(newQuestions)
            } else if (
                currentListComponentIndex < componentsForCharacteristics.length
            ) {
                const newQuestions = prepareCharacteristicQuestionsForComp(
                    activeQuestions,
                    currentQuestionIndex
                )
                setActiveQuestions(newQuestions)
            } else {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.partsOfIndependentClaim
                    return newValues
                })
            }
        },
    },
    partsOfIndependentClaim: {
        name: MachineNames.partsOfIndependentClaim,
        component: (
            <PartsOfIndependentClaim
                form={form}
                name={MachineNames.partsOfIndependentClaim}
            />
        ),
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.importantComponentsConnections
                return newValues
            })
        },
        formInputProps: {
            label: (
                <label>
                    Select a combination of components that you believe are
                    novel and nonobvious over all known prior art. The selected
                    components will be put in independent claim 1. All
                    non-selected components will NOT appear in claim 1 and may
                    instead be moved to subsequent children claims that depend
                    on claim 1 and incorporate all the features of claim 1 by
                    reference. To see how your selections impact the claim
                    language, look at the claim preview panel.
                </label>
            ),
        },
    },
    importantComponentsConnections: {
        component: <ImportantComponentConnections form={form} />,
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.importantComponentsArrangements
                return newValues
            })
        },
        name: MachineNames.importantComponentsConnections,
        formInputProps: {
            label: (
                <label>
                    Specify the{' '}
                    <Tooltip
                        title="In response to this prompt, specify physical connections for each component of the independent claims.  
                        Every component in the independent claims (e.g., claims that do not refer to any other claims, for example, claim 1) 
                        should be directly or indirectly related to every other component of the independent claim.  
                        If the connection is not a direct physical connection as requested in this prompt, an arrangement, orientation or functional relationship can be specified in later forms.

                        Ultimately, each component in an independent claim should be directly or indirectly related to every other component of the independent claim.  
                        Similarly, each component of a dependent claim should be directly or indirectly related to at least one component of an independent claim.  
                        As an example, component C can be indirectly related to component A if C is connected to Component B and component B is connected to component A."
                    >
                        <span style={{ textDecoration: 'underline' }}>
                            physical connections
                        </span>
                    </Tooltip>{' '}
                    (if applicable) between components.
                </label>
            ),
        },
    },
    importantComponentsArrangements: {
        component: <ImportantComponentsArrangements form={form} />,
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.functionalConnections
                return newValues
            })
        },
        name: MachineNames.importantComponentsArrangements,
        formInputProps: {
            label: (
                <label>
                    Now that we have looked at physical connections, let’s look
                    at relative arrangements (if any) of the components.
                </label>
            ),
        },
    },
    functionalConnections: {
        component: (
            <Form.List name="functionalConnections">
                {(fields, { add, remove }) => {
                    const primaryOptions = form.getFieldValue<
                        MachineForm['partsOfIndependentClaim']
                    >('partsOfIndependentClaim')
                    const formatedOptions = primaryOptions.map(
                        (item: string) => {
                            return extractComponentName(item, form)
                        }
                    )
                    return (
                        <>
                            {fields.map((field) => (
                                <Form.Item style={{ marginBottom: '24px' }}>
                                    <Row align="middle" gutter={[12, 0]}>
                                        <Col span={11}>
                                            <Form.Item noStyle shouldUpdate>
                                                {() => (
                                                    <Form.Item
                                                        {...field}
                                                        label="1st component"
                                                        name={[
                                                            field.name,
                                                            '1stComponent',
                                                        ]}
                                                        fieldKey={[
                                                            field.fieldKey as number,
                                                            '1stComponent',
                                                        ]}
                                                        hasFeedback
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message:
                                                                    '1st component is required',
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            options={formatedOptions.map(
                                                                (
                                                                    item: string,
                                                                    index: number
                                                                ) => ({
                                                                    value: primaryOptions[
                                                                        index
                                                                    ],
                                                                    label: item,
                                                                })
                                                            )}
                                                        />
                                                    </Form.Item>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col flex={1}>
                                            <Form.Item noStyle shouldUpdate>
                                                {() => (
                                                    <Form.Item
                                                        {...field}
                                                        label="2nd component"
                                                        name={[
                                                            field.name,
                                                            '2ndComponent',
                                                        ]}
                                                        fieldKey={[
                                                            field.fieldKey as number,
                                                            '2ndComponent',
                                                        ]}
                                                        hasFeedback
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message:
                                                                    '2nd component is required',
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            options={formatedOptions.map(
                                                                (
                                                                    item: string,
                                                                    index: number
                                                                ) => ({
                                                                    value: primaryOptions[
                                                                        index
                                                                    ],
                                                                    label: item,
                                                                })
                                                            )}
                                                        />
                                                    </Form.Item>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={2.5}>
                                            <MinusCircleOutlined
                                                className="dynamic-delete-button"
                                                onClick={() =>
                                                    remove(field.name)
                                                }
                                                style={{
                                                    color: '#f00',
                                                    fontSize: '1.6rem',
                                                    marginTop: '0.6rem',
                                                }}
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                name={[field.name, 'notSet']}
                                                valuePropName="checked"
                                                style={{ marginBottom: '20px' }}
                                            >
                                                <Checkbox>
                                                    I want to describe the
                                                    connection
                                                </Checkbox>
                                            </Form.Item>
                                        </Col>
                                        {form.getFieldValue<
                                            MachineValues['functionalConnections']
                                        >('functionalConnections')[field.name]
                                            ?.notSet ? (
                                            <Col span={24}>
                                                <Form.Item
                                                    noStyle
                                                    name={[
                                                        field.name,
                                                        'additionalConnectionInfo',
                                                    ]}
                                                    rules={[
                                                        {
                                                            validator:
                                                                async () => {
                                                                    const functionalConnections =
                                                                        form.getFieldValue<
                                                                            MachineForm['functionalConnections']
                                                                        >(
                                                                            'functionalConnections'
                                                                        )[
                                                                            field
                                                                                .key
                                                                        ]
                                                                    if (
                                                                        functionalConnections &&
                                                                        functionalConnections.notSet
                                                                    ) {
                                                                        const errorList =
                                                                            []
                                                                        if (
                                                                            functionalConnections[
                                                                                '2ndPart'
                                                                            ] ==
                                                                                null ||
                                                                            functionalConnections[
                                                                                '2ndPart'
                                                                            ] ===
                                                                                ''
                                                                        ) {
                                                                            errorList.push(
                                                                                ' 2nd part of description is required'
                                                                            )
                                                                        }
                                                                        if (
                                                                            errorList.length >
                                                                            0
                                                                        ) {
                                                                            throw new Error(
                                                                                errorList.toString()
                                                                            )
                                                                        }
                                                                    }
                                                                },
                                                        },
                                                    ]}
                                                >
                                                    <StyledFormItem
                                                        name={[
                                                            field.name,
                                                            '1stPart',
                                                        ]}
                                                    >
                                                        <StyledInputOptional
                                                            type="text"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        />
                                                    </StyledFormItem>
                                                    <StyledSpan>
                                                        the{' '}
                                                        {extractComponentName(
                                                            form.getFieldValue<
                                                                MachineForm['functionalConnections']
                                                            >(
                                                                'functionalConnections'
                                                            )[field.key]?.[
                                                                '1stComponent'
                                                            ],
                                                            form
                                                        ) ?? '1st Component'}
                                                    </StyledSpan>
                                                    <StyledFormItem
                                                        name={[
                                                            field.name,
                                                            '2ndPart',
                                                        ]}
                                                    >
                                                        <StyledInput
                                                            type="text"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        />
                                                    </StyledFormItem>
                                                    <StyledSpan>
                                                        the{' '}
                                                        {extractComponentName(
                                                            form.getFieldValue<
                                                                MachineForm['functionalConnections']
                                                            >(
                                                                'functionalConnections'
                                                            )[field.key]?.[
                                                                '2ndComponent'
                                                            ],
                                                            form
                                                        ) ?? '2nd Component'}
                                                    </StyledSpan>
                                                    <StyledFormItem
                                                        name={[
                                                            field.name,
                                                            '3rdPart',
                                                        ]}
                                                    >
                                                        <StyledInputOptional
                                                            type="text"
                                                            style={{
                                                                width: '150px',
                                                            }}
                                                        />
                                                    </StyledFormItem>
                                                </Form.Item>
                                            </Col>
                                        ) : (
                                            <></>
                                        )}
                                    </Row>
                                </Form.Item>
                            ))}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    block
                                >
                                    Add relationship
                                </Button>
                            </Form.Item>
                        </>
                    )
                }}
            </Form.List>
        ),
        onNext: () => {
            const partsOfDependentClaim = form.getFieldValue<
                MachineForm['partsOfDependentClaim']
            >('partsOfDependentClaim')
            if (partsOfDependentClaim && partsOfDependentClaim.length > 0) {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.dependantComponentsConnections
                    return newValues
                })
            } else {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.featuresPartsOfIndependentClaim
                    return newValues
                })
            }
        },
        name: MachineNames.functionalConnections,
        formInputProps: {
            label: (
                <label>
                    Are any components related via a functional relationship
                    rather than physical contact? If yes, add the relationships
                </label>
            ),
        },
    },
    dependantComponentsConnections: {
        // component: <DependantComponentConnections form={form} />,
        component: (
            <DependantComponentConnections
                form={form}
                setContentBasedItemsToReview={setContentBasedItemsToReview}
            />
        ),
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.featuresPartsOfIndependentClaim
                return newValues
            })
        },
        name: MachineNames.dependantComponentsConnections,
        formInputProps: {
            label: (
                <label>
                    For every component in a dependent claim, add a connection
                    to at least one component that is in an independent claim
                    that is directly or indirectly connected to a component in
                    an independent claim.
                </label>
            ),
        },
    },
    featuresPartsOfIndependentClaim: {
        name: MachineNames.featuresPartsOfIndependentClaim,
        component: (
            <FeaturesPartsOfIndependentClaim
                form={form}
                name={MachineNames.featuresPartsOfIndependentClaim}
            />
        ),
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    SharedNames.backgroundInvention
                return newValues
            })
        },
        formInputProps: {
            label: (
                <label>
                    Select a combination of features that you believe are novel
                    and nonobvious over all known prior art. The selected
                    components will be put in independent claim 1. All
                    non-selected components will NOT appear in claim 1 and may
                    instead be moved to subsequent children claims that depend
                    on claim 1 and incorporate all the features of claim 1 by
                    reference. To see how your selections impact the claim
                    language, look at the claim preview panel.
                </label>
            ),
        },
    },
    backgroundInvention: {
        component: (
            <CommunicatePatentPro
                form={form}
                setContentBasedItemsToReview={setContentBasedItemsToReview}
            />
        ),
        onNext: () => {
            const customSet = form.getFieldValue<
                MachineForm['backgroundInvention']['custom']
            >(['backgroundInvention', 'custom'])
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.customBackgroundOfInvention
                return newValues
            })
        },
        name: SharedNames.backgroundInvention,
        formInputProps: {
            // label: 'Please write Cross-Reference and Related Applications',
            label: 'Would you like to claim priority to the filing date of an earlier application or incorporate a document by reference into your patent application?  If so, it can be advantageous to talk to a patent professional.  There are several options available depending on the circumstances.  Also, mistakes can be impossible or costly to fix.',
        },
    },
    customBackgroundOfInvention: {
        component: <CustomBackgroundOfInnovation form={form} />,
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    SharedNames.summaryOfSelectedEmbodimentsOfTheInvention
                return newValues
            })
        },
        name: MachineNames.customBackgroundOfInvention,
        formInputProps: {
            label: 'List the advantage or desirable characteristic that your invention provides but existing options or alternatives fail to provide',
        },
    },
    summaryOfSelectedEmbodimentsOfTheInvention: {
        component: (
            <>
                <SummaryOfSelectedEmbodimentsOfTheInvention
                    form={form}
                    name={
                        SharedNames.summaryOfSelectedEmbodimentsOfTheInvention
                    }
                />
            </>
        ),
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.doneDescribing
                return newValues
            })
        },
        name: SharedNames.summaryOfSelectedEmbodimentsOfTheInvention,
        formInputProps: {
            label: 'Please confirm that you believe your selected combination of components and features are novel and nonobvious over all known prior art. The selected components will be put in independent claim 1. All non-selected components will NOT appear in claim 1 and may instead be moved to subsequent children claims that depend on claim 1 and incorporate all the features of claim 1 by reference. To see how your selections impact the claim language, look at the claim preview panel.',
        },
    },
    subSummaryOfSelectedEmbodimentsOfTheInvention: {
        component: (
            <>
                <SubSummaryOfSelectedEmbodimentsOfTheInvention
                    form={form as any}
                    subComponentIndex={getCurrentListItemIndex(
                        activeQuestions,
                        currentQuestionIndex,
                        MachineNames.subSummaryOfSelectedEmbodimentsOfTheInvention
                    )}
                />
            </>
        ),
        onNext: () => {
            setActiveQuestions((prev) => {
                const currentListItemIndex = getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex + 1,
                    MachineNames.subSummaryOfSelectedEmbodimentsOfTheInvention
                )
                let nextComponent
                const summaryOfSelectedEmbodimentsOfTheInvention =
                    form.getFieldValue<
                        MachineForm['summaryOfSelectedEmbodimentsOfTheInvention']
                    >('summaryOfSelectedEmbodimentsOfTheInvention') ?? []
                const isExistSubcomponent = currentListItemIndex
                if (
                    isExistSubcomponent <=
                    summaryOfSelectedEmbodimentsOfTheInvention.length
                ) {
                    if (
                        form.getFieldValue<
                            MachineForm['primaryComponentSubComponentsList']
                        >('primaryComponentSubComponentsList')[
                            summaryOfSelectedEmbodimentsOfTheInvention[
                                isExistSubcomponent
                            ]
                        ] === undefined
                    ) {
                        const newValues = [...prev]
                        newValues[currentQuestionIndex + 1] =
                            MachineNames.doneDescribing
                        return newValues
                    }
                    nextComponent =
                        currentListItemIndex <
                        summaryOfSelectedEmbodimentsOfTheInvention.length
                            ? MachineNames.subSummaryOfSelectedEmbodimentsOfTheInvention
                            : MachineNames.doneDescribing
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] = nextComponent
                    return newValues
                }
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.doneDescribing
                return newValues
            })
        },
        name: MachineNames.subSummaryOfSelectedEmbodimentsOfTheInvention,
        formInputProps: {
            label: undefined,
        },
    },
    abstractOfTheDisclosure: {
        component: <AbstractOfTheDisclosure form={form as any} />,
        name: MachineNames.abstractOfTheDisclosure,

        formInputProps: {
            label: 'Abstract of the disclosure',
        },
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.detailedDescription
                return newValues
            })
        },
    },
    detailedDescription: {
        component: (
            <DetailedDescription
                setContentBasedItemsToReview={setContentBasedItemsToReview}
                setItemsToReview={functions.setItemsToReview}
                userToggledQuestions={functions.userToggledQuestions}
            />
        ),
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] = MachineNames.lastPane
                return newValues
            })
        },
        name: MachineNames.detailedDescription,
        formInputProps: {
            label: 'Please write detailed  description ',
        },
    },
    [MachineNames.drawingsDescription]: {
        component: (
            <DrawingsDescription
                form={form}
                characteristicComponentIndex={getCurrentListItemIndex(
                    activeQuestions,
                    currentQuestionIndex,
                    MachineNames.characteristic
                )}
            />
        ),
        name: MachineNames.drawingsDescription,
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.abstractOfTheDisclosure
                return newValues
            })
        },
    },
    doneDescribing: {
        component: (
            <Form.Item name={['doneDescribing', 'indefiniteArticle']}>
                <Select
                    labelInValue
                    options={[
                        {
                            value: 'yes',
                            label: 'yes',
                        },
                        {
                            value: 'no',
                            label: 'no',
                        },
                    ]}
                />
            </Form.Item>
        ),
        onNext: () => {
            const done = form.getFieldValue<
                MachineForm['doneDescribing']['indefiniteArticle']
            >(['doneDescribing', 'indefiniteArticle'])
            if (done.value === 'yes') {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.drawingToolDescription
                    return newValues
                })
            } else {
                setActiveQuestions((prev) => {
                    const newValues = [...prev]
                    newValues[currentQuestionIndex + 1] =
                        MachineNames.extraOptions
                    return newValues
                })
            }
        },
        name: MachineNames.doneDescribing,
        formInputProps: {
            label: 'Are you done describing the machine?',
        },
    },
    extraOptions: {
        component: (
            <>
                <Form.Item label="Do you want to add another component?">
                    <Button
                        onClick={() => {
                            setCurrentQuestionIndex(
                                activeQuestions.indexOf(
                                    MachineNames.primaryComponents
                                )
                            )
                        }}
                        block
                    >
                        Go to components
                    </Button>
                </Form.Item>
                <Form.Item label="Do you want to add feature to components?">
                    <Button
                        onClick={() => {
                            setCurrentQuestionIndex(
                                activeQuestions.indexOf(
                                    MachineNames.mainSubcomponents
                                )
                            )
                        }}
                        block
                    >
                        Go to subcomponents
                    </Button>
                </Form.Item>
                <Form.Item label="Do you want to change characteristics?">
                    <Button
                        onClick={() => {
                            setCurrentQuestionIndex(
                                activeQuestions.indexOf(
                                    MachineNames.componentsForCharacteristics
                                )
                            )
                        }}
                        block
                    >
                        Go to characteristics
                    </Button>
                </Form.Item>
                <Form.Item
                    label="Do you need to talk to patent professional?"
                    name={[MachineNames.extraOptions, 'patent-proffesional']}
                    initialValue="no"
                >
                    <Select
                        labelInValue
                        options={[
                            {
                                value: 'yes',
                                label: 'yes',
                            },
                            {
                                value: 'no',
                                label: 'no',
                            },
                        ]}
                    />
                </Form.Item>
            </>
        ),
        name: MachineNames.extraOptions,
        onNext: () => {
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.drawingToolDescription
                return newValues
            })
        },
    },
    drawingToolDescription: {
        component: <></>,
        name: MachineNames.drawingToolDescription,
        formInputProps: {
            label: `The claims have been specified and now the elements of the claims should be shown in figures if the elements can be illustrated.

            Structural features can be shown in an illustrative black and white drawing or photograph. Generally speaking, photographs should only be used if photographs are the only practical medium for illustrating the claimed invention” or for a provisional application. However, even if a photograph is used in a provisional application, it may need to be converted to a drawing when a nonprovisional application is filed, which can result in complications, problems or additional expense in the future. Color should be avoided unless absolutely necessary to depict an element of the claims or to understand what is illustrated in the Figure. A petition may be required to accept a color photograph.
            
            Figures can be uploaded or drawn by the user in this application.`,
        },
        onNext: () => {
            functions.setDiagramScreen(true)
            setActiveQuestions((prev) => {
                const newValues = [...prev]
                newValues[currentQuestionIndex + 1] =
                    MachineNames.drawingsDescription
                return newValues
            })
        },
    },
    lastPane: {
        component: <></>,
        isLastQuestion: true,
        name: MachineNames.lastPane,
        formInputProps: {
            label: `Thank you for completing this form!`,
        },
    },
})
